import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MasterDetailModule, ServiceResponseModule } from '@sdbn/common';
import { DataProtectionRulesComponent } from './component/data-protection-rules.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceResponseModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule
  ],
  declarations: [
    DataProtectionRulesComponent
  ]
})
export class DataProtectionRulesModule { }

